import { RtoNationalSidingTypeKey } from './RtoNationalSidingTypeKey';

export const RtoNationalSidingType = {
  Aluminum: {
    type: RtoNationalSidingTypeKey.Aluminum,
    id: 'A',
  },
  Fiberglass: {
    type: RtoNationalSidingTypeKey.Fiberglass,
    id: 'F',
  },
  Steel: {
    type: RtoNationalSidingTypeKey.Steel,
    id: 'S',
  },
  Vinyl: {
    type: RtoNationalSidingTypeKey.Vinyl,
    id: 'V',
  },
  OtherWood: {
    type: RtoNationalSidingTypeKey.OtherWood,
    id: 'W',
  },
  T1_11: {
    type: RtoNationalSidingTypeKey.T1_11,
    id: 'T',
  },
  LpSmartSide: {
    type: RtoNationalSidingTypeKey.LpSmartSide,
    id: 'LP',
  },
  GpPlytanium: {
    type: RtoNationalSidingTypeKey.GpPlytanium,
    id: 'GP',
  },
  Duratemp: {
    type: RtoNationalSidingTypeKey.Duratemp,
    id: 'D',
  },
  Stucco: {
    type: RtoNationalSidingTypeKey.Stucco,
    id: 'SC',
  },
} as const;
